// import mapAwards from 'models/participants/mapAwards'
const CREATE_AWARD_UNIT = 'dofe-bo/participant/CREATE_AWARD_UNIT'
const CREATE_AWARD_UNIT_SUCCESS =
  'dofe-bo/participant/CREATE_AWARD_UNIT_SUCCESS'
const CREATE_AWARD_UNIT_FAIL = 'dofe-bo/participant/CREATE_AWARD_UNIT_FAIL'
const CHECK_UNIT = 'dofe-bo/UNIT/CHECK_UNIT'
const CHECK_UNIT_SUCCESS = 'dofe-bo/UNIT/CHECK_UNIT_SUCCESS'
const CHECK_UNIT_FAIL = 'dofe-bo/UNIT/CHECK_UNIT_FAIL'
const GET_QUESTIONS = 'dofe-bo/UNIT/GET_QUESTIONS'
const GET_QUESTIONS_SUCCESS = 'dofe-bo/UNIT/GET_QUESTIONS_SUCCESS'
const GET_QUESTIONS_FAIL = 'dofe-bo/UNIT/GET_QUESTIONS_FAIL'

const FETCH_UNITS = 'dofe-bo/AU/FETCH_UNITS'
const FETCH_UNITS_SUCCESS = `${FETCH_UNITS}_SUCCESS`
const FETCH_UNITS_FAIL = `${FETCH_UNITS}_FAIL`

const initialState = {
  loading: false,
  loaded: false,
  loadingUnits: false,
  questions: [],
  list: []
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case CREATE_AWARD_UNIT:
      return {
        ...state,
        loading: true
      }
    case CREATE_AWARD_UNIT_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true
      }
    case CREATE_AWARD_UNIT_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case CHECK_UNIT:
      return {
        ...state,
        loading: true
      }
    case CHECK_UNIT_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true
      }
    case CHECK_UNIT_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_QUESTIONS:
      return {
        ...state,
        loading: true
      }
    case GET_QUESTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        questions: action.result
      }
    case GET_QUESTIONS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case FETCH_UNITS:
      return {
        ...state,
        loadingUnits: true
      }
    case FETCH_UNITS_SUCCESS:
      return {
        ...state,
        loadingUnits: false,
        list: action.result || []
      }
    case FETCH_UNITS_FAIL:
      return {
        ...state,
        loadingUnits: false
      }
    default:
      return state
  }
}

export function createAwardUnit(data) {
  return {
    types: [
      CREATE_AWARD_UNIT,
      CREATE_AWARD_UNIT_SUCCESS,
      CREATE_AWARD_UNIT_FAIL
    ],
    promise: client =>
      client.post('api/award-unit-registration', {
        data,
        removeToken: true
      })
  }
}

export function fetchAwardUnits(
  countryId = 1,
  { organizationId, parentOrganizationId } = {}
) {
  const organizationIdQuery = organizationId
    ? `&organizationId=${organizationId}`
    : ''

  const parentOrganizationIdQuery = parentOrganizationId
    ? `&parentOrganizationId=${parentOrganizationId}`
    : ''

  return {
    types: [FETCH_UNITS, FETCH_UNITS_SUCCESS, FETCH_UNITS_FAIL],
    promise: client =>
      client.get(
        `api/participant-registrations/award-units?countryId=${countryId +
          organizationIdQuery}${parentOrganizationIdQuery}`,
        {
          removeToken: true
        }
      )
  }
}

export function checkOperatingAuthorities(name, countryId = 1) {
  const nameQuery = name ? `?name=${encodeURI(name)}` : '?name='

  return {
    types: [CHECK_UNIT, CHECK_UNIT_SUCCESS, CHECK_UNIT_FAIL],
    promise: client =>
      client.get(
        `api/award-unit-registrations/operating-authorities${nameQuery}&countryId=${countryId}`,
        {
          removeToken: true
        }
      )
  }
}

export function getAwardQuestions(organizationId) {
  return {
    types: [GET_QUESTIONS, GET_QUESTIONS_SUCCESS, GET_QUESTIONS_FAIL],
    promise: client =>
      client.get(
        `api/registration/profile-questions?organizationId=${organizationId}`,
        {
          removeToken: true
        }
      )
  }
}
